<div class="modal-header container-fluid d-flex flex-column h-100">
    <div class="d-flex align-items-center w-100">
        <h4 class="modal-title header-2 flex-grow-1">{{ title }}</h4>
        <button
        type="button"
        class="btn-close btn-close-white mx-1"
        aria-label="Close"
        (click)="activeModal.dismiss('Cross click')"
        ></button>
    </div>
  </div>
  <div class="p-3 overflow-auto w-100 px-4 flex-grow-1">
    <!-- <form class="mt-3" [formGroup]="form">
      <formly-form
        [model]="model"
        [fields]="fields"
        [options]="options"
        [form]="form"
      ></formly-form>
    </form> -->

    <div class="alert alert-danger">
      {{ enableFileUpload ? 'Please update the GitHub Repo link and upload the Defect Report to generate the Most Impacted Test Cases' : 
      'Please update the GitHub Repo link to generate the Impacted Test Cases' }}
    </div>

    <div>
      <div class="inp-grp d-flex align-items-center">
        <span class="grp-title"> Mapping Name </span>
        <span class="value-text no-act text-truncate"> {{ model.name }} </span>
      </div>
      <div class="inp-grp d-flex align-items-center">
        <span class="grp-title"> LLM </span>
        <span class="value-text no-act text-truncate"> {{ model.llmApiKey }} </span>
      </div>
      <div class="inp-grp d-flex align-items-center">
        <span class="grp-title"> Vector Database </span>
        <span class="value-text no-act text-truncate"> {{ model.vectorDatabase }} </span>
      </div>
      <div class="inp-grp d-flex align-items-center">
        <span class="grp-title"> Vector Database API Key </span>
        <input class="value-text no-act text-truncate" type="password" [(ngModel)]="model.vectorStoreApiKey">
      </div>
      <div class="inp-grp d-flex align-items-center">
        <span class="grp-title"> GitHub Token </span>
        <input class="value-text no-act text-truncate" type="password" [(ngModel)]="model.githubToken">
      </div>
      <div class="inp-grp d-flex align-items-center">
        <span class="grp-title"> Git Repo Link </span>
        <input class="value-text form-control" [(ngModel)]="model.githubLink">
      </div>
    </div>

    <div class="d-flex inp-grp mt-3" *ngIf="enableFileUpload">
      <span class="grp-title"> Defect Report </span>
      <div class="value-text">
        <app-file-upload
          [data]="fileUploadConfig"
          (filesSelected)="handleFilesSelected($event)"
        ></app-file-upload>
      </div>
    </div>

  </div>

  <div class="d-flex justify-content-end p-3">
    <button class="btn-accello-primary btn-accello" (click)="generate()"> Generate </button>
  </div>
